module.exports = __webpack_public_path__ + "img/b_intro_3_cn.12d5a60.png";